var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "6px",
    viewBox: "0 0 35 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F81101E9-72CE-43D2-A332-600CC26D46D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1179.000000, -4031.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(1179.000000, 4031.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#464646",
    x: 0,
    y: 0,
    width: 35,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-186-Copy-4",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(30.133556, 2.998903) scale(1, -1) translate(-30.133556, -2.998903) ",
    points: "28.4334337 3.99061106 30.0966242 2 31.8894078 4.0012692"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.f6fc37e7900ac19f8adbdf73a3bbb1b7.svg";
export { ForwardRef as ReactComponent };